import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../../../services/localization/LanguageContex";
import {
  Typography,
  Box,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import {
  getDataBySign,
  searchSign,
} from "../../../services/database/database_service";
import LoadingIndicator from "../components/LoadingIndicator";
import Tooltip from "@mui/material/Tooltip";



function SignSearchResult() {
  const { t, language } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const signTitle = queryParams.get("search_query");

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [signData, setSignData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const audioRef = useRef(null);

  useEffect(() => {
    // window.scrollTo(0, 0);
    setSearchTerm("");
    async function fetchSignData() {
      setLoading(true);
      try {
        const data = await getDataBySign(signTitle);
        if (data.documents) {
          setSignData(data.documents[0]);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchSignData();

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [signTitle]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const doSearch = async () => {
        if (searchTerm.trim() === "") {
          setSearchResults([]);
          return;
        }
        setIsSearching(true);
        try {
          const res = await searchSign(searchTerm);
          setSearchResults(res.documents);
        } catch (e) {
          setSearchResults([]);
          setError(e.message);
        } finally {
          setIsSearching(false);
        }
      };
      doSearch();
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  // Pause audio when user switches tabs (optional)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden && audioRef.current) {
        audioRef.current.pause();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // Auto play audio when signData changes
  useEffect(() => {
    if (audioRef.current && signData?.audioUrl) {
      audioRef.current.play().catch(() => {}); // ignore play errors
    }
  }, [signData]);

  // On button click, replay audio from start every time
  const handleAudioButtonClick = async () => {
    if (!audioRef.current) return;



    try {
    audioRef.current.currentTime = 0;
    await audioRef.current.play();
  } catch (err) {
    console.error("Audio playback failed:", err);
  }
  };


  const handleClick = () => {
    navigate(
      `/home/signsCategory/${encodeURIComponent(signData.category)}`
    );
  };

  if (!signData) return <LoadingIndicator />;

  return (
    <Box sx={{ px: { xs: 3, sm: 6, md: 6 }, pt: 2, pb: 4 }}>
      <Box sx={{ maxWidth: 400, mx: "auto", mt: 0, position: "relative" }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder={t("Search signs ...")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        {searchTerm && (
          <Box
            sx={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              bgcolor: "background.paper",
              boxShadow: 3,
              zIndex: 10,
              maxHeight: 300,
              overflowY: "auto",
              borderRadius: 1,
              mt: 1,
            }}
          >
            {isSearching ? (
              <Typography sx={{ p: 2 }} align="center">
                {t("Searching...")}...
              </Typography>
            ) : searchResults.length === 0 ? (
              <Typography sx={{ p: 2 }} align="center">
                {t("No results found")}
              </Typography>
            ) : (
              searchResults.map((result) => (
                <Box
                  key={result.id}
                  onClick={() =>
                    navigate(
                      `/home/signsCategory/result?search_query=${encodeURIComponent(
                        result.enTitle
                      )}`
                    )
                  }
                  sx={{
                    p: 2,
                    "&:hover": { bgcolor: "grey.100", cursor: "pointer" },
                  }}
                >
                  <Typography variant="subtitle2">{result.enTitle}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {result.dzTitle}
                  </Typography>

                </Box>
              ))
            )}
          </Box>
        )}
      </Box>

      <Typography
        variant="h4"
        gutterBottom
        align="center"
        sx={{
          fontSize: { xs: "1.5rem", sm: "1.7rem", md: "2rem" },
          mt: 1,
          mb: 1,
        }}
      >
        {/* {language === "en"
          ? signData.enTitle.charAt(0).toUpperCase() + signData.enTitle.slice(1)
          : signData.dzTitle
          ? signData.dzTitle
          : t(signData.enTitle) !== signData.enTitle
          ? t(signData.enTitle)
          : signData.enTitle.charAt(0).toUpperCase() +
            signData.enTitle.slice(1)} */}

          {language === "en"
          ? signData.enTitle
          : signData.dzTitle ? signData.dzTitle: t(signData.enTitle) }


        {/* help me navigate to : /home/signsCategory/result?search_query= signData.category on click*/}

         <Typography variant="body2" color="text.secondary">
  {language === "en" ? "Category: " : "དབྱེ་ཁག།: "}
  <Box
    component="span"
    sx={{
      cursor: "pointer",
      textDecoration: "underline",
      fontWeight: 500,
    }}
    onClick={handleClick}
  >
    {signData.category}
  </Box>
</Typography>
      </Typography>

      <Box display="flex" flexDirection="column" alignItems="center">
        {loading ? (
          <LoadingIndicator />
        ) : error ? (
          <Box textAlign="center" mt={4}>
            <Typography variant="h6" color="error">
              {error}
            </Typography>
          </Box>
        ) : (
          <Box sx={{ flexDirection: "column" }}>
            <Box
              component="img"
              src={signData.webpUrl}
              alt="sign webp"
              loading="lazy"
              sx={{
                width: "100%",
                height: { xs: 200, sm: 400, md: 500 },
                mb: 0,
                overflow: "hidden",
                position: "relative",
                objectFit: "contain",
              }}
            />
            {/* Hidden audio element */}
            <audio
              ref={audioRef}
              src={signData.audioUrl}
              style={{ display: "none" }}
              preload="auto"
            />
            {/* Replay button */}
             <Tooltip title={t("Play audio")}>
            <Button
              onClick={handleAudioButtonClick}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mx: "auto",
                borderRadius: 5,
                width: { xs: 20, sm: 20, md: 25 },
              }}
            >
              <VolumeUpIcon
                sx={{
                  color: "rgba(27,39,58,1)",
                  width: { xs: 20, sm: 20, md: 25 },
                }}
              />
            </Button>
            </Tooltip>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default SignSearchResult;

// import React, { useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useLanguage } from "../../../services/localization/LanguageContex";
// import { Typography, Box, TextField, InputAdornment } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import {
//   getDataBySign,
//   searchSign,
// } from "../../../services/database/database_service";
// import LoadingIndicator from "../components/LoadingIndicator";

// function SignSearchResult() {
//   const { t, language } = useLanguage();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const signTitle = queryParams.get("search_query");

//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [signData, setSignData] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [isSearching, setIsSearching] = useState(false);

//   const audioRef = useRef(null); // 👈 audio reference

//   useEffect(() => {
//     setSearchTerm("");
//     async function fetchSignData() {
//       setLoading(true);
//       try {
//         const data = await getDataBySign(signTitle);
//         if (data.documents) {
//           setSignData(data.documents[0]);
//         }
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     }
//     fetchSignData();

//     return () => {
//       if (audioRef.current) {
//         audioRef.current.pause();
//         audioRef.current.currentTime = 0;
//       }
//     };
//   }, [signTitle]);

//   useEffect(() => {
//     const delayDebounce = setTimeout(() => {
//       const doSearch = async () => {
//         if (searchTerm.trim() === "") {
//           setSearchResults([]);
//           return;
//         }
//         setIsSearching(true);
//         try {
//           const res = await searchSign(searchTerm);
//           setSearchResults(res.documents);
//         } catch (e) {
//           setSearchResults([]);
//           setError(e.message);
//         } finally {
//           setIsSearching(false);
//         }
//       };
//       doSearch();
//     }, 300);

//     return () => clearTimeout(delayDebounce);
//   }, [searchTerm]);

//   // Optional: pause audio when user switches tabs
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (document.hidden && audioRef.current) {
//         audioRef.current.pause();
//       }
//     };

//     document.addEventListener("visibilitychange", handleVisibilityChange);
//     return () => {
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//     };
//   }, []);

//   if (!signData) return <LoadingIndicator />;

//   return (
//     <Box
//       // sx={{ px: 1, pt: 1 }}
//       sx={{
//         px: { xs: 3, sm: 6, md: 6 }, pt: 2, pb: 4 }}
//     >
//       <Box
//         sx={{ maxWidth: 400, mx: "auto", mb: 1, mt: 1, position: "relative" }}
//       >
//         <TextField
//           fullWidth
//           variant="outlined"
//           placeholder={t("Search signs ...")}
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon />
//               </InputAdornment>
//             ),
//           }}
//         />

//         {searchTerm && (
//           <Box
//             sx={{
//               position: "absolute",
//               top: "100%",
//               left: 0,
//               right: 0,
//               bgcolor: "background.paper",
//               boxShadow: 3,
//               zIndex: 10,
//               maxHeight: 300,
//               overflowY: "auto",
//               borderRadius: 1,
//               mt: 1,
//             }}
//           >
//             {isSearching ? (
//               <Typography sx={{ p: 2 }} align="center">
//                 {t("Searching...")}...
//               </Typography>
//             ) : searchResults.length === 0 ? (
//               <Typography sx={{ p: 2 }} align="center">
//                 {t("No results found")}
//               </Typography>
//             ) : (
//               searchResults.map((result) => (
//                 <Box
//                   key={result.id}
//                   onClick={() =>
//                     navigate(
//                       `/home/signsCategory/result?search_query=${encodeURIComponent(
//                         result.enTitle
//                       )}`
//                     )
//                   }
//                   sx={{
//                     p: 2,
//                     "&:hover": { bgcolor: "grey.100", cursor: "pointer" },
//                   }}
//                 >
//                   <Typography variant="subtitle2">{result.enTitle}</Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {result.dzTitle}
//                   </Typography>
//                 </Box>
//               ))
//             )}
//           </Box>
//         )}
//       </Box>

//       <Typography
//         variant="h4"
//         gutterBottom
//         align="center"
//         sx={{
//           fontSize: { xs: "1.5rem", sm: "1.7rem", md: "2rem" },
//           mt: 4,
//         }}
//       >
//         {language === "en"
//           ? signData.enTitle.charAt(0).toUpperCase() + signData.enTitle.slice(1)
//           : signData.dzTitle
//           ? signData.dzTitle
//           : t(signData.enTitle) !== signData.enTitle
//           ? t(signData.enTitle)
//           : signData.enTitle.charAt(0).toUpperCase() +
//             signData.enTitle.slice(1)}
//       </Typography>

//       <Box display="flex" flexDirection="column" alignItems="center">
//         {loading ? (
//           <LoadingIndicator />
//         ) : error ? (
//           <Box textAlign="center" mt={4}>
//             <Typography variant="h6" color="error">
//               {error}
//             </Typography>
//           </Box>
//         ) : (
//           <Box sx={{ flexDirection: "column" }}>
//             <Box
//               component="img"
//               src={signData.webpUrl}
//               alt="sign webp"
//               loading="lazy"
//               // sx={{
//               //   width: { xs: 220, sm: 300, md: 400 },
//               //   height: { xs: 220, sm: 300, md: 400 },
//               // }}
//               sx={{
//                 width: "100%",
//                 height: { xs: 200, sm: 400, md: 500 },
//                 mb: 0,
//                 overflow: "hidden",
//                 position: "relative",
//                 objectFit: "contain",
//               }}
//             />
//             <Box
//               component="audio"
//               ref={audioRef}
//               src={signData.audioUrl}
//               controls
//               autoPlay
//               // sx={{ width: { xs: 210, sm: 300, md: 300 }, mt: 1 }}
//               sx={{
//                 width: { xs: 200, sm: 250, md: 350 },
//                 height: { xs: 25, sm: 40 }, // Set a fixed height for the audio player

//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 mx: "auto",
//               }}
//             />
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// }

// export default SignSearchResult;
